import { useEffect } from 'react'
import { useBucket } from '@mc/experiments-react'
import { useStaticData } from '@mc/static-data-react'
import { trackExperimentViewed } from '@mc/track-event'
import { useMCProBucketOverride } from '../../prcng-1266_v1_cm_dual_cta'
import { MC_PRO_TIER_FLAG_NAME, type MCProBucket } from '../constants'

// Only the Plans Page passes `trackExposure`, so exposure fires once per view.
// It is never gated on the bucket, or control stops enrolling with the variants.
// prcng-1270_v1 and prcng-1266_v1 can override the bucket; overridden visitors
// don't enrol here.
export const useMCProExperiment = ({ trackExposure = false } = {}) => {
  const { isGift } = useStaticData<{ isGift: boolean }>()
  const { bucket, isOverridden, proSlot, variant2Layout } =
    useMCProBucketOverride({
      bucket: useBucket<MCProBucket>(MC_PRO_TIER_FLAG_NAME),
      isGift,
      reportInvalid: trackExposure,
      trackExposure,
    })
  const shouldTrackExposure = trackExposure && !isGift && !isOverridden

  useEffect(() => {
    if (shouldTrackExposure) trackExperimentViewed(MC_PRO_TIER_FLAG_NAME)
  }, [shouldTrackExposure])

  const isVariant1 = bucket === 'variant_1'
  const isVariant2 = bucket === 'variant_2'
  const isVariant3 = bucket === 'variant_3'

  return {
    bucket,
    isVariant: isVariant1 || isVariant2 || isVariant3,
    isVariant1,
    isVariant2,
    isVariant3,
    proSlot,
    variant2Layout,
  }
}
